import { render, staticRenderFns } from "./NewServis.vue?vue&type=template&id=433f7d55&"
import script from "./NewServis.vue?vue&type=script&lang=js&"
export * from "./NewServis.vue?vue&type=script&lang=js&"
import style0 from "./NewServis.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports